import { render, staticRenderFns } from "./roleitem.vue?vue&type=template&id=a2b5bff0&scoped=true&"
import script from "./roleitem.vue?vue&type=script&lang=js&"
export * from "./roleitem.vue?vue&type=script&lang=js&"
import style0 from "./roleitem.vue?vue&type=style&index=0&id=a2b5bff0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2b5bff0",
  null
  
)

export default component.exports